<template>
    <div class="bill-inbox-col-right">
        <div class="bill-inbox-pdf-toolbar">
            <span class="ix-text-secondary ix-text-small">
                <i class="far fa-file-pdf mr-1"></i> Document
            </span>
            <a v-if="pdfUrl" :href="pdfUrl + '?download=1'"
               class="ix-btn" style="padding: 4px 10px; font-size: 0.8em;"
               target="_blank" title="Télécharger le document">
                <i class="far fa-download mr-1"></i> Télécharger
            </a>
        </div>

        <div class="bill-inbox-pdf-body">
            <template v-if="pdfUrl">
                <!-- Chargement en cours (vérification de l'URL) -->
                <div v-if="pdfLoading"
                     class="text-center py-4 ix-text-secondary bill-inbox-pdf-loading">
                    <i class="far fa-circle-notch fa-spin fa-2x mb-2"></i>
                    <div class="ix-text-small">Chargement du document...</div>
                </div>

                <!-- Erreur : URL inaccessible -->
                <div v-else-if="pdfError" class="text-center ix-text-secondary" style="padding: 32px 24px;">
                    <i class="far fa-file-times fa-2x mb-3" style="color: #adb5bd;"></i>
                    <div style="font-size: 0.95em; font-weight: 600; margin-bottom: 6px;">Document indisponible</div>
                    <div style="font-size: 0.82em;">Le document n'a pas pu être récupéré depuis la source externe.<br>Vérifiez la connexion à la source dans les paramètres connecteurs de prod-up .</div>
                </div>

                <!-- URL valide : afficher l'iframe -->
                <iframe v-else
                    :key="pdfUrl"
                    :src="pdfUrl"
                    style="width: 100%; height: 100%; border: none;">
                </iframe>
            </template>
            <div v-else class="text-center py-5 ix-text-secondary">
                <i class="far fa-file-slash fa-2x mb-2"></i>
                <div>Aucun document disponible</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BillInboxPdfViewer',

    props: {
        pdfUrl: { type: String, default: null },
    },

    data() {
        return {
            pdfLoading: false,
            pdfError: false,
        };
    },

    watch: {
        pdfUrl: {
            immediate: true,
            handler(newUrl) {
                this.pdfError   = false;
                this.pdfLoading = !!newUrl;
                if (!newUrl) return;

                fetch(newUrl, {
                    method:  'HEAD',
                    headers: { 'X-Requested-With': 'XMLHttpRequest' },
                })
                    .then(r => {
                        if (!r.ok) this.pdfError = true;
                    })
                    .catch(() => {
                        this.pdfError = true;
                    })
                    .finally(() => {
                        this.pdfLoading = false;
                    });
            },
        },
    },
};
</script>

<style scoped>
.bill-inbox-col-right {
    flex: 1;
    display: flex;
    flex-direction: column;
    background: #f8f9fa;
    overflow: hidden;
}

.bill-inbox-pdf-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    border-bottom: 1px solid #e8eaed;
    background: #fff;
    flex-shrink: 0;
}

.bill-inbox-pdf-body {
    flex: 1;
    overflow: hidden;
    position: relative;
}

.bill-inbox-pdf-loading {
    position: absolute;
    inset: 0;
    background: #f8f9fa;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

@media (max-width: 768px) {
    .bill-inbox-col-right {
        flex: 1;
        min-height: 40vh;
    }
}
</style>
